var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CampaignFormModel, } from '.';
export var factoryCampaign = function (campaign, menuSetting, profileIds, demographicSetting) {
    if (campaign === void 0) { campaign = {}; }
    var _a = campaign.insertionOrderBudgets, insertionOrderBudgets = _a === void 0 ? [] : _a;
    var campaignBudgets = insertionOrderBudgets
        .map(function (budget) {
        return budget.campaignBudgets ? budget.campaignBudgets : [];
    })
        .flat();
    var temporaryCampaignBudgets = insertionOrderBudgets
        .map(function (budget) {
        return budget.latestRequest.temporaryCampaignBudgets
            ? budget.latestRequest.temporaryCampaignBudgets
            : [];
    })
        .flat();
    return new CampaignFormModel(__assign(__assign({}, campaign), { campaignBudgets: campaignBudgets, temporaryCampaignBudgets: temporaryCampaignBudgets, menuSetting: menuSetting, demographicSetting: demographicSetting, profileIds: profileIds }));
};
export default factoryCampaign;
